import { useFormik } from 'formik'
import React, { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useLocation, useNavigate } from 'react-router-dom'
import { toast } from 'react-toastify'
import styled from 'styled-components'
import * as Yup from 'yup'
import api from '../../../api'
import Responsive from '../../../assets/config/Responsive'
import Colors from '../../../assets/styles/Colors'
import { Container } from '../../../assets/styles/GlobalStyle'
import Button from '../../../components/Button'
import Input from '../../../components/Input'
import Loader from '../../../components/Loader'
import ScreenHeader from '../../../components/ScreenHeader'
import { Helmet } from 'react-helmet-async'
//
//
const ResetPasswordStepOne = () => {
  //
  const location = useLocation()
  const mailFromLoginPage = typeof location?.state === 'string' ? location?.state : undefined
  //
  //
  const { t } = useTranslation()
  //
  //
  const emailRegex = /.+@.+\..+/gi
  const [email, setEmail] = useState(mailFromLoginPage ? mailFromLoginPage : '')
  const [disableForm, setDisableForm] = useState(false)
  const [resetPasswordSeendEmail, { isLoading }] = api.useResetPasswordSeendEmailMutation()
  const navigate = useNavigate()
  //
  //
  const ResetPassword = async () => {
    if (emailRegex.test(email)) {
      try {
        await resetPasswordSeendEmail({ email }).unwrap()
        setDisableForm(true)
        toast.success(`${t('linkSentToYourEmail')}`)
        navigate('/login')
      } catch (error: any) {
        if (error?.data?.errors?.constructor === Array) {
          const firstError = error.data.errors[0]
          const errorMessage = firstError.message
          toast.error(errorMessage)
        } else {
          toast.error(`${t('anErrorOccurred')}`)
        }
        setDisableForm(false)
      }
    } else if (email.trim().length <= 0) {
      toast.warn(`${t('pleaseEnterEmail')}`)
      setDisableForm(false)
    } else {
      toast.warn(`${t('enterValidMail')}`)
      setDisableForm(false)
    }
  }

  // yup validations schema
  const InfoValidationSchema = Yup.object({
    email: Yup.string()
      .matches(/^\S*$/, `${t('spaceValidation')}`)
      .email(`${t('enterValidMail')}`)
      .required(`${t('required')}`),
  })
  // initial values
  const initialValues = {
    email: email || '',
  }
  // formi state
  const formik = useFormik({
    initialValues: initialValues,
    validationSchema: InfoValidationSchema,
    enableReinitialize: true,
    onSubmit: (values) => {
      console.log(values)
    },
  })

  const MainLoading = isLoading
  //
  //
  return MainLoading ? (
    <Loader />
  ) : (
    <>
      <Helmet>
        <title>{t('passwordHelmetTitle')}</title>
        <meta name="description" content={`${t('passwordHelmetTitle')}`} />
        <link rel="canonical" href={window.location.href} />
      </Helmet>
      <ScreenHeader text={t('homePage')} url="/" />
      <Container>
        <MainWrapper>
          <LargeTitle>{t('enterYourEmail')}</LargeTitle>

          <Wrapper>
            <CustomForm>
              <Input
                id="email"
                label={t('email')}
                type="email"
                placeholder=""
                value={email}
                name="email"
                onChange={(value) => [setEmail(value), formik.setFieldValue('email', value)]}
                error={formik.errors.email && formik.touched.email ? true : false}
                errorText={formik.errors.email}
                onBlur={formik.handleBlur}
                width={'fullWidth'}
                style={{ marginBottom: '30px' }}
              />

              <Button
                disabled={email && formik.isValid === true ? false : true || (disableForm && true)}
                onClick={ResetPassword}
                text={t('send')}
                btnStyleType="primary"
                fullWidth={true}
              />
            </CustomForm>
          </Wrapper>
        </MainWrapper>
      </Container>
    </>
  )
}

const Wrapper = styled.div`
  background-color: ${Colors.white};
  padding: 48px 64px 56px 64px;
  max-width: 528px;
  margin: 0 auto 140px auto;

  /* responsive */
  ${Responsive.mobile} {
    padding: 32px 24px 40px 24px;
    margin-bottom: 100px;
  }
`
const CustomForm = styled.div`
  margin-bottom: 25px;
`
const MainWrapper = styled.div`
  /*  */
`
const LargeTitle = styled.h1`
  font-size: 36px;
  line-height: 40px;
  color: ${Colors.primaryBlack};
  text-align: center;
  margin-top: 56px;
  margin-bottom: 56px;
  text-transform: capitalize;

  /* responsive */
  ${Responsive.tablet} {
    font-size: 24px;
    line-height: 26px;
  }

  /* responsive */
  ${Responsive.mobile} {
    font-size: 18px;
    line-height: 20px;
    margin-bottom: 56px;
    margin-top: 56px;
  }
`

export default ResetPasswordStepOne
